<template>
  <div>
    <Tabs :animated="false" type="card" @on-click="tabPage">
      <TabPane label="服务工单" name="1">
        <service-order :n="getServiceList"></service-order>
      </TabPane>
      <TabPane label="商机成交" name="2">
        <business-deal :n="getBusinessList"></business-deal>
      </TabPane>
      <TabPane label="活动管理" name="3">
        <activity-manage :n="getActivityList"></activity-manage>
      </TabPane>
    </Tabs>
  </div>
</template>

<script type="text/ecmascript-6">
  import serviceOrder from './components/serviceWorkOrder/index';
  import businessDeal from './components/businessDeal/index';
  import activityManage from './components/activityManage/index';
  
  export default {
    name:'specialrules',
    mounted(){
      this.getWhiteList++
    },
    components: {
      serviceOrder,
      businessDeal,
      activityManage
    },
    data() {
      return {
        getServiceList:0,
        getBusinessList:0,
        getActivityList:0
      }
    },
    methods:{ 
      tabPage(name){
        // console.log(name)
        switch (name) {
          case '1':
            this.getServiceList++
            break;
          case '2':
            this.getBusinessList++
            break;
          case '3':
            this.getActivityList++
            break;
        }
      }
    }
  }
</script>

<style scoped>
</style>
